import {
    Box,
    Typography,
    useTheme,
    Divider,
    // Avatar,
    Stack,
    IconButton
} from "@mui/material";
import React, {useState} from 'react';
import { tokens } from "../../theme";
import EditIcon from '@mui/icons-material/Edit';
import SystemUserEdit from "./SystemUserEdit";


const SystemUserComponent = ({ systemUser }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [openSystemUserEdit, setOpenSystemUserEdit] = useState(false);

    const handleSystemUserEdit = () => {
        setOpenSystemUserEdit(true);
    }

    const handleCloseSystemUserEdit = () => {
        setOpenSystemUserEdit(false);
    }

    return (
        <Stack
            sx={{
                width: "100%", flexGrow: 1, overflowY: "scroll" 
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    borderRadius: 1,
                }}
                p={2}
            >
                {/* MODAL Appeal edit */}
                <SystemUserEdit
                    systemUser={systemUser}
                    open={openSystemUserEdit}
                    handleClose={handleCloseSystemUserEdit}
                >
                </SystemUserEdit>

                {/*  */}
                <Stack
                    direction="row"
                    alignItems={"center"}
                    justifyContent="space-between"
                >
                    <Stack direction="row" spacing={2}>
                        {" "}
                        
                        {/* <AccountCircleIcon /> */}
                        
                        <Stack spacing={0.3}>
                            <Typography
                                variant="h4"
                                fontWeight="bold"
                                sx={{ color: colors.grey[100] }}
                            >
                                ID: {systemUser.id}
                            </Typography>
                            <Typography variant="caption">
                                Login: {systemUser.login}
                            </Typography>
                            <Typography variant="caption">
                                {systemUser.name} {systemUser.surname}
                            </Typography>
                            
                        </Stack>
                    </Stack>
                    <Stack alignItems={"top"}>
                        <IconButton onClick={() => {
                            handleSystemUserEdit()
                        }}>
                            <EditIcon />
                        </IconButton>
                    </Stack>
                </Stack>
                <Divider/>
            </Box>
        </Stack>
    );
};

export default SystemUserComponent;